var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconDigiWallet64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_16999)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7145 8.4519H21.0084C18.7946 8.4519 17 10.2465 17 12.4604V52.5448C17 54.7586 18.7946 56.5533 21.0084 56.5533H39.7145C41.9283 56.5533 43.723 54.7586 43.723 52.5448V12.4604C43.723 10.2465 41.9283 8.4519 39.7145 8.4519Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7145 8.4519H21.0084C18.7946 8.4519 17 10.2465 17 12.4604V52.5448C17 54.7586 18.7946 56.5533 21.0084 56.5533H39.7145C41.9283 56.5533 43.723 54.7586 43.723 52.5448V12.4604C43.723 10.2465 41.9283 8.4519 39.7145 8.4519Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 49.6816H43.723V52.5448C43.723 54.7586 41.9283 56.5533 39.7145 56.5533H21.0084C18.7946 56.5533 17 54.7586 17 52.5448V49.6816Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3615 54.8352C31.324 54.8352 32.1043 54.0661 32.1043 53.1173C32.1043 52.1685 31.324 51.3994 30.3615 51.3994C29.3989 51.3994 28.6187 52.1685 28.6187 53.1173C28.6187 54.0661 29.3989 54.8352 30.3615 54.8352Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8755 11.8879H35.0086",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1916_16999",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 46,
    y: 23,
    width: 11,
    height: 18
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.154 23.6311L46.7308 30.212V33.8081L55.154 40.389L56.7485 39.1692V24.9673L55.154 23.6311Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1916_16999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5835 22.657C54.8104 24.7354 55.9238 27.8531 55.9238 32.01C55.9238 36.1669 54.8104 39.2846 52.5835 41.3631",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5752 25.3293C50.8021 26.814 51.9155 29.0409 51.9155 32.0101C51.9155 34.9793 50.8021 37.2062 48.5752 38.6908",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1551 29.3379C47.7119 29.9317 47.9902 30.8225 47.9902 32.0102C47.9902 33.1979 47.7119 34.0886 47.1551 34.6825",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_16999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconDigiWallet64);
export default __webpack_public_path__ + "static/media/pictogramBeaconDigiWallet64.5d6d112102704bb60927cc5126796fbe.svg";
export { ForwardRef as ReactComponent };